import { Link } from "react-router-dom";

export default function TC() {
  const pageStyle = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f4f6f8",
    padding: "20px",
  };

  const cardStyle = {
    maxWidth: "800px",
    width: "100%",
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  };

  const headingStyle = {
    fontSize: "28px",
    marginBottom: "24px",
    color: "#222",
  };

  const paragraphStyle = {
    marginBottom: "16px",
    color: "#444",
    fontSize: "16px",
  };

  const backStyle = {
    display: "inline-block",
    marginBottom: "20px",
    color: "#2563eb",
    textDecoration: "none",
    fontSize: "14px",
    cursor: "pointer",
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <Link to="/" style={backStyle}>
          ← Back
        </Link>

        <h1 style={headingStyle}>Terms & Conditions</h1>

        <p style={paragraphStyle}>
          By using JobSniper, you agree not to upload harmful, illegal, or
          copyrighted data you do not own.
        </p>

        <p style={paragraphStyle}>
          JobSniper provides AI-based analysis and learning recommendations.
          Outcomes are not guaranteed and are informational in nature.
        </p>

        <p style={paragraphStyle}>
          Payments grant access to premium features such as advanced analysis
          and generated learning flows.
        </p>

        <p style={paragraphStyle}>
          Misuse of the platform may lead to account termination.
        </p>

        <p style={paragraphStyle}>
          All disputes are subject to Indian jurisdiction.
        </p>
      </div>
    </div>
  );
}